module.exports = __webpack_public_path__ + "static/media/team-len.8a1e72be.jpg";